//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {GetRentPartner} from 'service/cmssg'
import { formatStandardTitle } from '@/utils/standard'
export default {
    data () {
        return {
            RentPartnerdata:"",
            id:""
        }
    },
    components: {
    },
    mounted () {
        // document.title="租赁详情"
        formatStandardTitle('租赁详情')
        this.id = this.$route.query.id;
        this.init();
    },
    methods: {
        init: function () {
            var _this = this;
            var postData = {
                ID:_this.id
            };
            GetRentPartner(postData,function (result) {
                if (result.state == 1) {
                    var data = result.data;
                    if (data != null) {
                        //显示btn
                        if (!_this.isHideBtn(data)) {
                            $(".zcButton").show();
                        }
                        _this.RentPartnerdata = data;
                        $("#Title").html(data.Title);
                        $("#Content").html(data.Content);
                    }
                }
            })
        },
        isHideBtn:function (data) {
            var u = navigator.userAgent, app = navigator.appVersion;
            var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
            if (isiOS) {
                if (data.IOSURL == null || data.IOSURL.replace(/(^\s*)|(\s*$)/g, "").length == 0) {
                    return true;
                }
                //如果IOS审核则打开，审核完 关闭
                //return true;
            }
            return false;
        },
        RentCarApp:function () {
            var _this = this;
            if (_this.RentPartnerdata != null) {
                if (_this.RentPartnerdata.DeliverableType == "0") {
                    location.href = _this.RentPartnerdata.H5URL;
                } else {
                    //与app交互
                    $teld.rentCar(_this.RentPartnerdata)
                }
            }
        },

    }
}



// WEBPACK FOOTER //
// ./src/module/PicActivity/CarInfo.vue